/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { useMemo } from 'react'
import { Dropdown } from '@hashicorp/mds-react/components'
import makeUrls, { type CalendarEvent } from './makeUrls'
import { vercelSplit } from '@web/cms'

function transformEvent(event) {
	return Object.keys(event).reduce((acc, key) => {
		if (typeof event[key] === 'string') {
			acc[key] = vercelSplit(event[key])
			return acc
		}

		acc[key] = event[key]
		return acc
	}, {})
}

type CalendarURLs = ReturnType<typeof makeUrls>
const AddToCalendarDropdown = ({
	event,
	dropdownCta,
}: {
	event: CalendarEvent
	dropdownCta: string
}) => {
	const urls = useMemo<CalendarURLs>(() => {
		return makeUrls(transformEvent(event) as CalendarEvent)
	}, [event])
	return (
		<div>
			<Dropdown.Root>
				<Dropdown.ToggleButton
					text={vercelSplit(dropdownCta)}
					color="secondary"
					size="small"
				/>
				<Dropdown.Content listPosition="bottom-left">
					<Dropdown.List>
						{urls.map((url) => {
							return (
								<Dropdown.ListItem.Interactive
									key={url.name}
									text={url.name}
									href={url.calendar}
									isHrefExternal
								/>
							)
						})}
					</Dropdown.List>
				</Dropdown.Content>
			</Dropdown.Root>
		</div>
	)
}

export default AddToCalendarDropdown
